import { render, staticRenderFns } from "./BusquedaTramitesView.vue?vue&type=template&id=6677a25c"
import script from "./BusquedaTramitesView.vue?vue&type=script&lang=ts"
export * from "./BusquedaTramitesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports